import { RcClasses } from '../../../../foundation';
export var RcLinearProgressClasses = RcClasses(['buffer', 'colorPrimary', 'barColorPrimary', 'dashedColorPrimary'], 'RcLinearProgress');
